import { useSyncExternalStore } from "react";

type LogItem = {
    timestamp: number;
    type: "log" | "error";
    message: string;
    args: unknown[];
}

const logs: LogItem[] = [];
function createLogItem(type: LogItem["type"], message: string, ...args: unknown[]): LogItem {
    return {
        timestamp: Date.now(),
        type,
        message,
        args
    };
}
function dispatch(logItem: LogItem): void {
    console.log("[Logger]", logItem);
    const event = new CustomEvent("fuzion.logger.log", { detail: logItem });
    window.dispatchEvent(event);
}
export const Logger = Object.freeze({
    log(message: string, ...args: unknown[]): void {
        const logItem = createLogItem("log", message, ...args);
        logs.push(logItem);
        dispatch(logItem);
    },
    error(message: string, ...args: unknown[]): void {
        const logItem = createLogItem("error", message, ...args);
        logs.push(logItem);
        dispatch(logItem);
    }
});

export function useLoggerState() {
    const state = useSyncExternalStore(Subscribe, getSnapshot);
    const lastMessage = state.length > 0 ? state[state.length - 1] : null;
    return [lastMessage, state] as const;
}

function Subscribe(listener: () => void): () => void {
    window.addEventListener("fuzion.logger.log", listener);
    return () => {
        window.removeEventListener("fuzion.logger.log", listener);
    };
}
function getSnapshot(): LogItem[] {
    return logs;
}

